import { BRAZILIAN_STATES } from '@constants';

export const SELECT_OPTIONS = Object.entries(BRAZILIAN_STATES).map(
  ([key, _value]) => ({
    value: key,
    label: key,
  }),
);
